/* src/map/gmaps-loader.js — load the Google Maps JavaScript API once.
 * The deployed go.lacak.io renders /#/online/trackers on the Google Maps JS API; with a
 * key we do the same for true parity. The key is read from VITE_GMAPS_KEY (.env.local,
 * gitignored). Loads the `geometry` library (used for measure/length).
 */

let promise = null

export function loadGoogleMaps() {
  if (typeof window !== 'undefined' && window.google && window.google.maps) {
    return Promise.resolve(window.google.maps)
  }
  if (promise) return promise

  const key = import.meta.env.VITE_GMAPS_KEY
  promise = new Promise((resolve, reject) => {
    if (!key) { reject(new Error('VITE_GMAPS_KEY missing')); return }
    window.__gmapsReady = () => resolve(window.google.maps)
    const s = document.createElement('script')
    s.src =
      'https://maps.googleapis.com/maps/api/js?key=' +
      encodeURIComponent(key) +
      '&libraries=geometry&callback=__gmapsReady&loading=async'
    s.async = true
    s.defer = true
    s.onerror = () => reject(new Error('Google Maps failed to load'))
    document.head.appendChild(s)
  })
  return promise
}

export default loadGoogleMaps
